<template>
  <div id="shop-list">
    <call />
    <pop-alert />
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="search"></footer-app>
      <!-- search -->
      <section :class="{'fade-base': true, 'fade': pageFade}">
        <div class="l-search">
          <div class="l-search__head">
              <div class="l-search__box-search">
                <div class="l-search__box-search--box d-flex c-box-coupon">
                  <div><input type="text" placeholder="検索キーワード" v-model="inputSearch" /></div>
                  <button @click.prevent="searchName()">検索</button>
                </div>
              </div>
            </div>
          <div class="l-search__head--white">
            <ul class="c-tab-category">
              <li class="c-tab-category__item" :class="{ 'is-active': shopCategoryType == 0 && shopType !== 'reservation'}"
                v-on:click="getShopCategoryType(0)"><a>すべて</a></li>
              <li class="c-tab-category__item" 
                v-if="isReservationEnabled" 
                :class="{ 'is-active': shopCategoryType == 0 && shopType == 'reservation'}"
                v-on:click="getShopCategoryType(0,'reservation')"
              ><a>来店予約</a></li>
              <li class="c-tab-category__item" v-for="(category, index) in shopCategoryTypes" :key="index"
                :class="{ 'is-active': shopCategoryType == category.id}" v-on:click="getShopCategoryType(category.id)">
                <a>{{ category.name }}</a></li>
            </ul>
          </div>
          <div class="l-search__body">
            <div class="l-search__title">ショップ一覧 ({{ totalProviders }})</div>
            <ul class="c-list-shop mb-24" v-if="providers.length > 0">
              <li v-for="(item, index) in providers" :key="index">
                <div>
                  <div class="c-list-shop__img_line">
                  <div class="c-list-shop__img js-keep-ratio" data-ratio="1" v-on:click="redirectShopDetail(item.id)">
                    <img v-bind:src="getImgSrc(item.image[0])" alt="">
                  </div>
                  </div>
                  <div class="c-list-shop__info">
                    <div class="c-list-shop__info--area" v-on:click="redirectShopDetail(item.id)">{{ item.location }}</div>
                    <div class="c-list-shop__info--name" v-on:click="redirectShopDetail(item.id)">{{ item.shopName }}</div>

                    <button v-if="follows.includes(item.id)" class="c-btn-follow is-active box-center" v-on:click="deleteFollows(item.id)">
                      <span class="c-btn-follow__active">フォロー中</span>
                    </button>
                    <button v-else class="c-btn-follow box-center" v-on:click="addFollows(item.id)">
                      <span class="c-btn-follow__unactive">フォローする</span>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
            <div v-else>
              条件に一致しませんでした
            </div>
          </div>
        </div>
        
        <!-- modal show congestion degree in header -->
        <modal_congestion_situation :counter-blocks=counterBlocks></modal_congestion_situation>
        <!-- modal show required login -->
        <modal_login_required></modal_login_required>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Menu from "../components/Menu.vue";
import ModalCongestionSituation from "../components/ModalCongestionSituation.vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getProviderByShopCategory } from "../store/firestore.js";
import PopAlert from "../components/PopAlert.vue";

export default Vue.extend({
  name: "ShopList",
  components: {
    'footer-app': Footer,
    'header-app': Header,
    'menu-app': Menu,
    'modal_congestion_situation': ModalCongestionSituation,
    'modal_login_required': ModalLoginRequired,
    PopAlert
  },
  mixins: [Tenant],
  data () {
    //console.log("route query",this.$route.query.type || null);
    return {
      queryShopType:this.$route.query.type || null,
      shopType:this.$route.query.type || null,
      shopCategoryType: this.$route.params.category || 0,
      providers: [],
      inputSearch: '',
      totalProviders: 0,
      shopCategoryTypes: [
        { id: 1, name: 'スーパーマーケット総合スーパー' },
        { id: 2, name: 'ファッション' },
        { id: 3, name: 'グッズ' },
        { id: 4, name: 'サービス' },
        { id: 5, name: 'グルメ・フード' },
        { id: 6, name: 'アミューズメント' },
      ],
      isReservationEnabled :false
    }
  },
  created () {
    this.inputSearch = this.$route.query.keyword;
    const categoryType = this.$route.params.category;
    if (categoryType) {
      this.shopCategoryType = categoryType;
    }
    const shopType = this.$route.query.type;
    if (shopType == "reservation") {
      this.getDataListProviders(this.shopCategoryType,shopType)
    } else {
      this.getDataListProviders(this.shopCategoryType)
    }
    this.getReservationEnabled();
  },
  mounted() {
    Common.initDom();
  },
  updated() {
      this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async getReservationEnabled () {
      const result = await getProviderByShopCategory(0)
      if (!result) return
      //来店予約の場合ここでさらに絞り込む
      var arr = [];
      for (var i=0; i<result.length; i++ ) {
        //来店予約のある店舗を検索
        if (result[i].reservationEnabled) {
          arr.push(result[i])
        }
      }
      this.isReservationEnabled = (arr.length > 0) ? true : false;
    },
    async getDataListProviders (categoryType,type) {
      const result = await getProviderByShopCategory(categoryType)
      if (!result) return
      this.providers = result

      //来店予約の場合ここでさらに絞り込む
      if (type == "reservation") {
        var arr = [];
        for (var i=0; i<result.length; i++ ) {
          //来店予約のある店舗を検索
          if (result[i].reservationEnabled) {
            arr.push(result[i])
          }
        }
        this.providers = arr;
      }
      if (this.inputSearch) {
        // キーワード検索
        this.providers = this.providers.filter(provider => {
          const searchText = this.inputSearch.replace(/　/g, " ");
          const searchTexts = searchText.split(" ");
          let hit = true;
          for (let i = 0; i < searchTexts.length; i++) {
            if (searchTexts[i]) {
              const text = searchTexts[i].toUpperCase();
              if (provider.shopName.toUpperCase().indexOf(text) === -1 && provider.about.toUpperCase().indexOf(text) === -1) {
                hit = false;
                break;
              }
            }
          }
          return hit;
        });
      }

      await this.getTotalListProviders()
    },
    async getTotalListProviders () {
      this.totalProviders = Object.keys(this.providers).length
    },
    getShopCategoryType (categoryType,type = null) {
      this.shopType = type;
      /*
      let params = {name: 'ShopList'}
      if (this.queryShopType == "reservation") {
        params["query"] =  { type: 'reservation' }
      }
      if (categoryType > 0){
        params["params"] = { category: categoryType }
        this.$router.push(params)
      }  
      else {
        this.$router.push('/shop/list');
      }
      */
      // get providers by shop category type
      this.shopCategoryType = categoryType
      this.getDataListProviders(categoryType,type)
    },
    searchName () {
      /*
      const shopType = this.$route.query.type;
      if (shopType == "reservation") {
        this.getDataListProviders(this.shopCategoryType,shopType)
      } else {
        this.getDataListProviders(this.shopCategoryType)
      }
      */
      this.getDataListProviders(this.shopCategoryType,this.shopType)
    }
  },
  watch: {
    $route () {
      // ページ表示中にメニューの来店予約がタップされた際の対応
      location.reload()
    }
  }
});
</script>